<template>
  <StandardResourceService
    title="携程代理通"
    v-model="activeTab"
    :tab-list="tabList">
    <OrderRecordsComponent v-if="activeTab==='orderRecord'"></OrderRecordsComponent>
    <AssociatedQuoteComponent v-else-if="activeTab==='associatedQuote'"></AssociatedQuoteComponent>
    <AssociatedAccountComponent v-else-if="activeTab==='linkAccount'"></AssociatedAccountComponent>
  </StandardResourceService>
</template>

<script>
import StandardResourceService from '@/customComponents/standard/StandardResourceService.vue'
import OrderRecordsComponent from './components/OrderRecordsComponent.vue'
import AssociatedQuoteComponent from './components/AssociatedQuoteComponent.vue'
import AssociatedAccountComponent from './components/AssociatedAccountComponent.vue'

export default {
  name: 'CtripHome',
  components: {
    StandardResourceService,
    OrderRecordsComponent,
    AssociatedQuoteComponent,
    AssociatedAccountComponent
  },
  data () {
    return {
      activeTab: 'orderRecord',
      tabList: [
        { label: '订单记录', key: 'orderRecord' },
        { label: '关联报价', key: 'associatedQuote' },
        { label: '关联账号', key: 'linkAccount' }
      ]
    }
  }
}
</script>

<style scoped lang="less">
</style>
